/**
 * Вход через телеграм — обмен одноразового токена на сессию.
 */

import { useMutation } from '@tanstack/react-query';
import { client } from './client';
import { setAccessToken } from './client';

interface ExchangeRequest {
  token: string;
}

interface ExchangeResponse {
  accessToken: string;
  user: {
    id: string;
    login: string;
    role: string;
    orgId: string;
  };
}

export function useTelegramExchange(): ReturnType<
  typeof useMutation<ExchangeResponse, Error, ExchangeRequest>
> {
  return useMutation({
    mutationFn: async (body: ExchangeRequest) => {
      const { data } = await client.post<ExchangeResponse>('/auth/telegram/exchange', body);
      // Refresh-токен уезжает в httpOnly-куку на стороне сервера,
      // здесь остаётся только короткоживущий access
      setAccessToken(data.accessToken);
      return data;
    },
  });
}
